import React, { type PropsWithChildren, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { View } from 'react-native';

import { Button, Container, useResponsive } from '@sg/garnish';

import { useTelemetry } from '@order/Telemetry';

import { giftCardCheckoutSubmitMessages } from './GiftCardCheckoutSubmit.messages';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardCheckoutSubmit = (props: GiftCardCheckoutSubmitProps) => {
  const { isSubmitting, isDisabled, onPress } = props;
  const { track } = useTelemetry();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const onBtnPress = useCallback(async () => {
    track('gift.purchase_cta_tapped');
    await onPress();
  }, [onPress, track]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <GiftCardCheckoutSubmitContainer>
      <Button
        size="large"
        palette="primary"
        onPress={onBtnPress}
        isLoading={isSubmitting}
        disabled={isDisabled}
      >
        <FormattedMessage {...giftCardCheckoutSubmitMessages.total} />
      </Button>
    </GiftCardCheckoutSubmitContainer>
  );
};

// ─────────────────────────────────────────────────────────────────────────────

const GiftCardCheckoutSubmitContainer = (props: PropsWithChildren) => {
  const { currentBreakpoint } = useResponsive();

  if (currentBreakpoint.isXS) {
    return <Container>{props.children}</Container>;
  }

  return <View>{props.children}</View>;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardCheckoutSubmitProps = {
  isSubmitting: boolean;
  isDisabled?: boolean;
  onPress: () => Promise<void>;
};
